module.exports = __webpack_public_path__ + "img/build-example.946fb975.png";